import Page, { getStaticProps, getStaticPaths } from '#src/page'

export { getStaticPaths, getStaticProps }
export default Page
